import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Checkbox } from 'react-toolbox';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import ChecklistResponseNote from './checklistResponseNote';
import { formatTelephone } from '../../../../../../../../utils';
import styles from 'styles/form';
import S from '../styles.scss';
import RTCheckbox from 'styles/checkbox.scss';

const ChecklistPhaseContactInfo = (props) => {
  const {
    phone_numbers,
    assessmentScheduling,
    contactInfoConfirmed,
    handlePhoneNumber,
    submitContactInfo,
  } = props;
  const oneNumber = phone_numbers.length === 1;
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>Scheduling Checklist Phase Contact Info</h4>
    </div>
    <div className={S.checklistContainer}>
      <p>Do you want to receive text updates at the following number{oneNumber ? '' : 's'}?</p>
      <br />
      <ChecklistResponseNote noteKey="okToTextNote" />
      {phone_numbers.map((n, i) => {
        const { id, ok_to_text, number } = n;
        return (<Checkbox
          key={id}
          checked={ok_to_text}
          label={formatTelephone(number)}
          theme={RTCheckbox}
          className={styles.checkboxListItem}
          onChange={val => handlePhoneNumber(i, 'ok_to_text', val)}
        />);
      })}
      <br />
      <br />
    </div>
    <br />
    <div className={S.checklistContainer}>
      <Button
        label="Confirm Texting Permissions"
        flat inverse ripple
        className={S.saveButton}
        onClick={() => submitContactInfo()}
      />
      {(contactInfoConfirmed && assessmentScheduling) && <Fragment>
        <br />
        <br />
        { /* eslint-disable max-len */ }
        <p>OK, let{'\''}s get you scheduled! I can offer a morning or afternoon appointment. Your measure tech will call you the night before or morning of to narrow down the time frame.</p>
      </Fragment>}
    </div>
  </Card>);
};

ChecklistPhaseContactInfo.propTypes = {
  user: PropTypes.string,
  assessmentScheduling: PropTypes.bool,
  phone_numbers: PropTypes.array,
  contactInfoConfirmed: PropTypes.bool,
  handlePhoneNumber: PropTypes.func,
  submitContactInfo: PropTypes.func,
};

export default ChecklistPhaseContactInfo;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistPhaseContactInfo.jsx